import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/Board/chat/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const SET_LAST_LOADED_ID = NAMESPACE + 'SET_LAST_LOADED_ID'
export const SET_HEARTBEAT = NAMESPACE + 'SET_HEARTBEAT'
export const SET_SORT_BY_REPLY = NAMESPACE + 'SET_SORT_BY_REPLY'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const SET_UNREAD_MESSAGE_COUNT = NAMESPACE + 'SET_UNREAD_MESSAGE_COUNT'
export const INCREASE_UNREAD_MESSAGE_COUNT = NAMESPACE + 'INCREASE_UNREAD_MESSAGE_COUNT'
export const SET_REPLY_LOAD_STATUS = NAMESPACE + 'SET_REPLY_LOAD_STATUS'
export const SET_LAST_LOADED_REPLY_ID = NAMESPACE + 'SET_LAST_LOADED_REPLY_ID'
export const INCREASE_REPLIES_COUNT = NAMESPACE + 'INCREASE_REPLIES_COUNT'
export const SET_LIKED = NAMESPACE + 'SET_LIKED'
export const SET_LIKES = NAMESPACE + 'SET_LIKES'
export const INCREASE_LIKE_COUNT = NAMESPACE + 'INCREASE_LIKE_COUNT'
export const DECREASE_LIKE_COUNT = NAMESPACE + 'DECREASE_LIKE_COUNT'
export const ADD_REPLY = NAMESPACE + 'ADD_REPLY'
export const ADD_REPLIES_ARRAY = NAMESPACE + 'ADD_REPLIES_ARRAY'

const messageDefaults = {
  message: null,
  messageId: null,
  replies: [],
  repliesCount: 0,
  isLiked: false,
  likeCount: 0,
  likes: null,
  lastLoadedId: null,
  isLoading: false,
  isLoaded: false
}

const defaultBoardState = {
  messages: [],
  messagesById: {},
  lastLoadedId: null,
  isLoading: false,
  isLoaded: false,
  unreadMessageCount: 0,
  heartbeat: null,
  sortByReply: true
}

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.boardId]: {
          ...defaultBoardState,
        }
      }
    case SET_LOAD_STATUS:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          isLoading: action.payload.isLoading,
          isLoaded: action.payload.isLoaded,
        }
      } : state
    case SET_LAST_LOADED_ID:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          lastLoadedId: action.payload.lastLoadedId
        }
      } : state
    case SET_HEARTBEAT:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          heartbeat: action.payload.heartbeat
        }
      } : state
    case SET_SORT_BY_REPLY:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          messages: [],
          messagesById: {},
          lastLoadedId: null,
          isLoading: false,
          isLoaded: false,
          sortByReply: action.payload.sortByReply
        }
      } : state
    case ADD:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          messages: addUniqueValueToArray({
            array: state[action.payload.boardId].messages,
            value: action.payload.message.id,
            index: action.payload.message.index
          }),
          messagesById: {
            ...state[action.payload.boardId].messagesById,
            [action.payload.message.id]: {
              ...messageDefaults,
              ...action.payload.message
            }
          }
        }
      } : state
    case ADD_ARRAY: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          messages: [ ...state[action.payload.boardId].messages ],
          messagesById: { ...state[action.payload.boardId].messagesById }
        }
      }

      action.payload.array.forEach(message => {
        newState[action.payload.boardId].messages = addUniqueValueToArray({
          array: newState[action.payload.boardId].messages,
          value: message.id,
          index: message.index
        })

        newState[action.payload.boardId].messagesById[message.id] = {
          ...messageDefaults,
          ...message
        }

        if (message.replies) {
          newState[action.payload.boardId].messagesById[message.id].replies = []
          message.replies.forEach(reply => {
            newState[action.payload.boardId].messagesById[message.id].replies = addUniqueValueToArray({
              array: newState[action.payload.boardId].messagesById[message.id].replies,
              value: reply.id,
              index: reply.index
            })
            newState[action.payload.boardId].messagesById[reply.id] = {
              ...messageDefaults,
              ...reply
            }
          })
        }
      })
      return newState
    }
    case SET_UNREAD_MESSAGE_COUNT:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          unreadMessageCount: action.payload.count
        }
      } : state
    case INCREASE_UNREAD_MESSAGE_COUNT:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          unreadMessageCount: state[action.payload.boardId].unreadMessageCount + action.payload.count
        }
      } : state
    case SET_REPLY_LOAD_STATUS: {
      if (!state[action.payload.boardId]) return state

      const { messageId, isLoading, isLoaded } = action.payload
 
      if (!state[action.payload.boardId].messagesById[messageId]) return state // Cannot operate on not yet loaded message

      return {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          messagesById: {
            ...state[action.payload.boardId].messagesById,
            [messageId]: {
              ...state[action.payload.boardId].messagesById[messageId],
              isLoading,
              isLoaded
            }
          }
        }
      }
    }
    case SET_LAST_LOADED_REPLY_ID: {
      if (!state[action.payload.boardId]) return state

      const { messageId, lastLoadedId } = action.payload

      if (!state[action.payload.boardId].messagesById[messageId]) return state // Cannot operate on not yet loaded message

      return {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          messagesById: {
            ...state[action.payload.boardId].messagesById,
            [messageId]: {
              ...state[action.payload.boardId].messagesById[messageId],
              lastLoadedId
            }
          }
        }
      }
    }
    case INCREASE_REPLIES_COUNT: {
      if (!state[action.payload.boardId]) return state

      const { messageId } = action.payload

      if (!state[action.payload.boardId].messagesById[messageId]) return state // Cannot operate on not yet loaded message

      return {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          messagesById: {
            ...state[action.payload.boardId].messagesById,
            [messageId]: {
              ...state[action.payload.boardId].messagesById[messageId],
              repliesCount: state[action.payload.boardId].messagesById[messageId].repliesCount + 1
            }
          }
        }
      }
    }
    case SET_LIKED: {
      if (!state[action.payload.boardId]) return state

      const { messageId, isLiked } = action.payload

      if (!state[action.payload.boardId].messagesById[messageId]) return state // Cannot operate on not yet loaded message

      return {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          messagesById: {
            ...state[action.payload.boardId].messagesById,
            [messageId]: {
              ...state[action.payload.boardId].messagesById[messageId],
              isLiked
            }
          }
        }
      }
    }
    case SET_LIKES: {
      if (!state[action.payload.boardId]) return state

      const { messageId, likes } = action.payload

      if (!state[action.payload.boardId].messagesById[messageId]) return state // Cannot operate on not yet loaded message

      return {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          messagesById: {
            ...state[action.payload.boardId].messagesById,
            [messageId]: {
              ...state[action.payload.boardId].messagesById[messageId],
              likes
            }
          }
        }
      }
    }
    case INCREASE_LIKE_COUNT: {
      if (!state[action.payload.boardId]) return state

      const { messageId } = action.payload

      if (!state[action.payload.boardId].messagesById[messageId]) return state // Cannot operate on not yet loaded message

      return {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          messagesById: {
            ...state[action.payload.boardId].messagesById,
            [messageId]: {
              ...state[action.payload.boardId].messagesById[messageId],
              likeCount: state[action.payload.boardId].messagesById[messageId].likeCount + 1
            }
          }
        }
      }
    }
    case DECREASE_LIKE_COUNT: {
      if (!state[action.payload.boardId]) return state

      const { messageId } = action.payload

      if (!state[action.payload.boardId].messagesById[messageId]) return state // Cannot operate on not yet loaded message

      return {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          messagesById: {
            ...state[action.payload.boardId].messagesById,
            [messageId]: {
              ...state[action.payload.boardId].messagesById[messageId],
              likeCount: state[action.payload.boardId].messagesById[messageId].likeCount - 1
            }
          }
        }
      }
    }
    case ADD_REPLY: {
      if (!state[action.payload.boardId]) return state

      const { messageId, reply, index } = action.payload

      if (!state[action.payload.boardId].messagesById[messageId]) return state // Cannot add reply to not yet loaded message

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          messagesById: {
            ...state[action.payload.boardId].messagesById,
            [reply.id]: {
              ...messageDefaults,
              ...reply
            },
            [messageId]: {
              ...state[action.payload.boardId].messagesById[messageId],
              replies: addUniqueValueToArray({
                array: state[action.payload.boardId].messagesById[messageId].replies,
                value: reply.id,
                index
              })
            }
          }
        }
      }

      return newState
    }
    case ADD_REPLIES_ARRAY: {
      if (!state[action.payload.boardId]) return state

      const { messageId, array } = action.payload

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          messagesById: { ...state[action.payload.boardId].messagesById }
        }
      }

      array.forEach(reply => {
        if (!newState[action.payload.boardId].messagesById[messageId]) return // Cannot add reply to not yet loaded message
        newState[action.payload.boardId].messagesById[messageId].replies = addUniqueValueToArray({
          array: newState[action.payload.boardId].messagesById[messageId].replies,
          value: reply.id,
          index: reply.index
        })
        newState[action.payload.boardId].messagesById[reply.id] = {
          ...messageDefaults,
          ...reply
        }
      })
      return newState
    }
    default: return state
  }
}

export function setLoadStatus ({ boardId, isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      boardId,
      isLoading,
      isLoaded,
    }
  }
}

export function setLastLoadedId ({ boardId, lastLoadedId }) {
  return {
    type: SET_LAST_LOADED_ID,
    payload: {
      boardId,
      lastLoadedId,
    }
  }
}

export function setHeartbeat ({ boardId, heartbeat }) {
  return {
    type: SET_HEARTBEAT,
    payload: {
      boardId,
      heartbeat,
    }
  }
}

export function setSortByReply ({ boardId, sortByReply }) {
  return {
    type: SET_SORT_BY_REPLY,
    payload: {
      boardId,
      sortByReply,
    }
  }
}

export function add ({ boardId, message }) {
  return {
    type: ADD,
    payload: {
      boardId,
      message,
    }
  }
}

export function addArray ({ boardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      boardId,
      array,
    }
  }
}

export function setUnreadMessageCount ({ boardId, count }) {
  return {
    type: SET_UNREAD_MESSAGE_COUNT,
    payload: {
      boardId,
      count,
    }
  }
}

export function increaseUnreadMessageCount ({ boardId, count = 1 }) {
  return {
    type: INCREASE_UNREAD_MESSAGE_COUNT,
    payload: {
      boardId,
      count,
    }
  }
}

export function setReplyLoadStatus ({ boardId, messageId, isLoading, isLoaded }) {
  return {
    type: SET_REPLY_LOAD_STATUS,
    payload: {
      boardId,
      messageId,
      isLoading,
      isLoaded,
    }
  }
}

export function setLastLoadedReplyId ({ boardId, messageId, lastLoadedId }) {
  return {
    type: SET_LAST_LOADED_REPLY_ID,
    payload: {
      boardId,
      messageId,
      lastLoadedId,
    }
  }
}

export function increaseRepliesCount ({ boardId, messageId }) {
  return {
    type: INCREASE_REPLIES_COUNT,
    payload: {
      boardId,
      messageId,
    }
  }
}

export function setLiked ({ boardId, messageId, isLiked }) {
  return {
    type: SET_LIKED,
    payload: {
      boardId,
      messageId,
      isLiked,
    }
  }
}

export function setLikes ({ boardId, messageId, likes }) {
  return {
    type: SET_LIKES,
    payload: {
      boardId,
      messageId,
      likes,
    }
  }
}

export function increaseLikeCount ({ boardId, messageId }) {
  return {
    type: INCREASE_LIKE_COUNT,
    payload: {
      boardId,
      messageId,
    }
  }
}

export function decreaseLikeCount ({ boardId, messageId }) {
  return {
    type: DECREASE_LIKE_COUNT,
    payload: {
      boardId,
      messageId,
    }
  }
}

export function addReply ({ boardId, messageId, index, reply }) {
  return {
    type: ADD_REPLY,
    payload: {
      boardId,
      messageId,
      index,
      reply,
    }
  }
}

export function addRepliesArray ({ boardId, messageId, array }) {
  return {
    type: ADD_REPLIES_ARRAY,
    payload: {
      boardId,
      messageId,
      array
    }
  }
}
